import React, { useEffect } from 'react';
import ReactGA from "react-ga4";

const PageNotFound = () => {
  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", page: window.location.pathname });
    }, []);

    return (
    <>
        <div className="error-container">
          <h1 className="text-center text-fade-color">Error 404</h1>
          <div className="error-message">
            <img className="error-icon" src="../404.png" alt="Error 404" />
            <h2 className="text-color">Sorry...</h2>
            <h4 className="text-color mb-0">The page you are looking for does not exist.</h4>
            <div className="error-buttons">
              <a className="btn btn-primary d-block" href="/">Home</a>
            </div>
          </div>
        </div>{/* [ALERTS]*/}<div className="alerts-container"> </div>
      </>
    )
}

export default PageNotFound